module.exports = PortalI18n;